// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.5776 13.0962L22.252 15.977V17.502H13.75V15.502H18.4046L17.3436 14.6701L18.5776 13.0962Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.7519 18.4983H22.2542V20.4983H17.5993L18.6603 21.3302L17.4263 22.9041L13.7519 20.0233V18.4983Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8762 14C12.0139 15.103 11.5 16.4915 11.5 18C11.5 19.5085 12.0139 20.897 12.8762 22H2V20C2 16.6863 4.68629 14 8 14H12.8762Z"}}]};

const UserTransmitFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-transmit-filled',
    ref,
    icon: element,
  },
));

UserTransmitFilledIcon.displayName = 'UserTransmitFilledIcon';

export default UserTransmitFilledIcon;
